import Error from 'next/error'
import { MetaSeo } from '../../components/index'
import { PAGINEDETAIL, NEWS } from '../../utils/endpoint'
import { api, getApiClient } from '../../utils'
import React from 'react'
import PropTypes from 'prop-types'
import NewsDetailTemplate from '../../components/template/NewsTemplate/NewsDetailTemplate/NewsDetailTemplate'

const NewsDetail = ({ newsItem, page, statusCode }) => {
  if (!page) return <Error statusCode={statusCode} />

  return (
    <>
      <NewsDetailTemplate newsItem={newsItem} page={page} />
    </>
  )
}

export async function getServerSideProps({ params, locale, res, req }) {
  const api = getApiClient(req)
  const headers = req?.headers?.cookie ? { cookie: req.headers.cookie } : undefined

  try {
    const response = await api.get(`${NEWS}${params.slug}/`, {
      params: { lang: locale },
      headers,
    })
    const newsItem = await response.data

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'news-detail',
        lang: locale,
        content_type_id: newsItem.model,
        object_id: newsItem.id,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }
    return {
      props: { key: newsItem.id, newsItem, page, ...toolbarProps },
    }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return {
      props: { statusCode: 404 },
    }
  }
}

NewsDetail.propTypes = {
  page: PropTypes.object,
  statusCode: PropTypes.number,
  newsItem: PropTypes.object,
}

export default NewsDetail
